import React from 'react';
import { Link } from 'react-router-dom';

// 1. Importar las imágenes directamente
import medellinImg from '../assets/images/main_citys/medellin.png';
import envigadoImg from '../assets/images/main_citys/envigado.png';
import sabanetaImg from '../assets/images/main_citys/sabaneta.png';
import itaguiImg from '../assets/images/main_citys/itagui.png';

// 2. Usar las variables importadas en el array
const municipalities = [
  { name: 'Medellín', image: medellinImg,url:'MEDELLIN' },
  { name: 'Envigado', image: envigadoImg,url:'ENVIGADO' },
  { name: 'Sabaneta', image: sabanetaImg,url:'SABANETA' },
  { name: 'Itagüí', image: itaguiImg,url:'ITAGUI' },
];

const FeaturedMunicipalities = () => {
  return (
    <div className="w-full">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {municipalities.map((muni, index) => (
            <Link to={`/properties?municipio=${muni.url}`} key={muni.name}>
              <div 
                className="group relative rounded-lg overflow-hidden shadow-lg transform hover:-translate-y-2 transition-transform duration-300"
                style={{ animation: `fade-in-up 0.5s ease-out ${index * 0.15}s forwards`, opacity: 1 }}
              >
                {/* La etiqueta img ahora usa la variable de la imagen importada */}
                <img src={muni.image} alt={muni.name} className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6">
                  <h3 className="text-white text-3xl font-bold drop-shadow-lg">{muni.name}</h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedMunicipalities;
